module.exports = __webpack_public_path__ + "static/media/Sky_NuovaZelanda.ac2fba50.png";